fragment AiEmailTemplate on Campaign {
    id
    status
    htmlUrlPath
    description
    editions {
        edges {
            node {
                id
                status
                emailTemplate {
                    id
                    name
                    thumbnailUrl
                    subject
                    previewText
                    bodyForWeb
                }
            }
        }
    }
}
